import React from "react";
import "./TermsAndConditions.css";
import { Link } from "react-router-dom";
const PPIRules = () => {
  return (
    <div className="page-body">
    <div className="terms-container">
     {/* <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
          <h5 className="page-title mt-3"><strong>PPI Rules</strong></h5>
          <div className="breadcrumb m-0 text-end">
              <Link to="/compliance-center">Compliance Center</Link>  &nbsp;&gt;&nbsp;
            <strong>PPI Rules</strong>
          </div>
        </div> */}
 <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
  <h5 className="page-title mt-3">
    <p style={{fontWeight:"600"}}>PPI Rules</p>
  </h5>
<div className="breadcrumb m-0 text-end">
  <Link to="/" className="breadcrumb-link">
    Home
  </Link>
  &nbsp;&gt;&nbsp;
  <Link to="/compliance-center" className="breadcrumb-link">
    Compliance Center
  </Link>
  &nbsp;&gt;&nbsp;
  <span className="breadcrumb-current">PPI Rules</span>
</div>
</div>

   

<p data-fontsize="41" data-lineheight="61"><strong><span>Master Directions on Prepaid Payment Instruments (PPIs) (Updated as on November 12, 2021) Issued by RBI</span></strong></p>
<p class="has-medium-font-size">Clause 13.3&nbsp;:&nbsp;Non-bank PPI issuer cannot transfer the outstanding balance to its Profit &amp; Loss account for at least three years from the expiry date of PPI. In case the PPI holder approaches the PPI issuer for refund of such amount, at any time after the expiry date of PPI, then the same shall be paid to the PPI holder in a bank account.</p>
<p class="has-text-color has-vivid-cyan-blue-color" style={{color:"blue"
}}>For More Details click on the below link:</p>
<p class="has-text-color has-vivid-cyan-blue-color"><a href="https://rbi.org.in/scripts/NotificationUser.aspx?Id=12156&amp;fn=9&amp;Mode=0" target="_blank" rel="noopener">https://rbi.org.in/scripts/NotificationUser.aspx?Id=12156&amp;fn=9&amp;Mode=0</a></p>



  </div>
  </div>
  );
};

export default PPIRules;
